import React, { useState } from 'react';
import { Button, Statistic, Drawer, Form, Input, Select, InputNumber, message } from 'antd';
import { AiFillCreditCard } from 'react-icons/ai';
import './AddBalanceComponent.styles.scss';
import CurrencyIcon from '../../../Common/CurrencyIcon';
import { useGlobalState } from '../../../../store/state';
import { useParams } from 'react-router';
import { AddCreditToCompany } from '../../../../apis/Admin/Brands/AddCreditToCompany';

const { Item, useForm } = Form;
const { TextArea } = Input;
const { Option } = Select;
const AddBalanceComponent = ({ className, balance, companyDetails }) => {
  const [walletForm] = useForm();
  const [user] = useGlobalState('user');
  const params = useParams();
  const [visible, setVisible] = useState(false);

  const showDrawer = () => {
    setVisible(true);
  };

  const onClose = () => {
    setVisible(false);
  };

  // const AddCreditToCompany = () =>{
  //     console.log("vl")
  //     showDrawer()
  // }

  const creditAddingForm = (value) =>{
    console.log('value', value);

    // let _data = {
    //     ...value,
    // }
    AddCreditToCompany(user.accessToken, params.companyId, value).then(({ status, response })=>{
      console.log('wallet filling', response);
      if (status === 200) {
        message.success('Wallet Updated Successfully');
        onClose();
        companyDetails();
        walletForm.resetFields();
      } else {
        message.error('There is some issue while updating Balance');
      }
    });
  };

  return (
    <div className={`${className}`}>
      <div className="common_card admin_company_cred p-3 h-100">
        <div className="d-flex justify-content-between">
          <div className="">
            <h6 className="pt-2"><strong>Credits</strong></h6>
          </div>
          <div className="">
            <AiFillCreditCard size={60}/>
          </div>
        </div>
        <div className="admin_company_cred_bal py-4 mt-2">
          <h5 className="m-0">Current Balance</h5>
          <div className="admin_company_cred_bal--val">
            {CurrencyIcon()}<Statistic className="custom_number_format"
              value={balance}
              precision={2}/>
          </div>
        </div>
        <div className="admin_company_cred_act mt-4">
          <Button className="common_button w-100"
            onClick={showDrawer}>Add Credits</Button>
        </div>

        <Drawer title="Add Credit to this company"
          placement="right"
          onClose={onClose}
          visible={visible}
          width={320}>
          <Form
            onFinish={creditAddingForm}
            form={walletForm}
          >
            <Item name="camapignid"
              initialValue="">
              <Input className="common_input"
                size="large"
                placeholder="Campaign Id"
                disabled/>
            </Item>
            <Item name="amount"
              rules={[{ required: true, message: 'Amount can\'t be empty' }]}>
              <Input prefix={CurrencyIcon()}
                type="number"
                className="common_input w-100"
                size="large"
                placeholder="Amount to be added to wallet"/>
            </Item>
            <Item name="transaction_notes"
              initialValue="">
              <TextArea className="common_input"
                size="large"
                placeholder="notes if any"/>
            </Item>
            <Item name="paymentMethod"
              initialValue="wallet">
              <Input className="common_input"
                size="large"
                placeholder="Payment Method"
                disabled/>
            </Item>
            <Item name="transactionType"
              initialValue="credit">
              <Input className="common_input"
                size="large"
                placeholder="Credit"
                disabled/>
            </Item>
            <Item>
              <Button htmlType="submit"
                className="common_button">Add Credits</Button>
            </Item>
          </Form>
        </Drawer>
      </div>
    </div>
  );
};

export default AddBalanceComponent;
